<template>
	<div class="text-center p-10">
		<p class="text-lg font-semibold mb-6">
			Kategoria <b>{{ categoryName }}</b> nuk ka ende nje produkt
		</p>
		<p>
			Ju lutem verifikoni te keni menune e axhornuar te Biznesit dhe te keni foto me kualitet te larte. Verifikoni
			permasat dhe dimensionin e fotove perpara se ti karikoni.
		</p>
		<div class="pt-6">
			<app-button class="btn btn-success w-full" icon="plus" @click="$emit('click')">
				Add Product
			</app-button>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'NewProductInfo',
		props: ['categoryName'],
	};
</script>

<style scoped></style>
